import { render } from "./AdmLogin.vue?vue&type=template&id=3c196f04&scoped=true"
import script from "./AdmLogin.vue?vue&type=script&lang=js"
export * from "./AdmLogin.vue?vue&type=script&lang=js"

import "./AdmLogin.vue?vue&type=style&index=0&id=3c196f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c196f04"]])

export default __exports__